import vars from '../helpers';

const init = () => {
	const $buttons = $('.js-scroll-button');

	$buttons.on('click', (e) => {
		const $button = $(e.currentTarget);
		const y = `.js-scroll-target[data-target${vars.isMobile() ? '-mobile' : ''}="${$button.data('target')}"]`;
		const k = vars.isMobile() ? 3 : 1;
		const offsetY = Math.floor($(y).height() * k) - 1;

		if ($button.data('arrow')) {
			const type = $button.data('arrow');

			vars.$html.trigger('scroll-arrow-button-click', type);
		} else {
			const name = $(y).data('name');

			vars.$html.trigger('scroll-button-click', name);
		}

		gsap.to(window, {
			duration: 1,
			scrollTo: {
				y,
				offsetY,
			},
			ease: 'power3.inOut',
		}, 0);
	});
};

export default {
	init,
};
